import { render, staticRenderFns } from "./AKSK.vue?vue&type=template&id=f3a920be&"
import script from "./AKSK.vue?vue&type=script&lang=js&"
export * from "./AKSK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports